module.exports = __webpack_public_path__ + "static/partner1-445ea50d8e83989e2aba80db322545d8.png";